import { Fragment, type ReactNode } from 'react';
import { ProductHeader } from './ProductHeader';
import { ProductFooter } from './ProductFooter';
import type { RoleLoginTheme } from './roleLoginThemes';
import './role-login.css';

interface RoleLoginShellProps {
  theme: RoleLoginTheme;
  children: ReactNode;
  meta?: ReactNode;
}

export function RoleLoginShell({ theme, children, meta }: RoleLoginShellProps) {
  return (
    <div className="rl" data-role={theme.slug} data-theme="light">
      <div className="rl__chrome-header">
        <ProductHeader product="assess" />
      </div>

      <main className="rl__stage">
        <section className="rl__spread" aria-label={theme.label}>
          {/* ── Form pane ── */}
          <div className="rl__form-pane">
            <header className="rl__header">
              <span className="rl__kicker">{theme.kicker}</span>
              <div className="rl__mark" aria-hidden="true">
                <span className="rl__mark-glyph">{theme.glyph}</span>
              </div>
              <h1
                className="rl__title"
                dangerouslySetInnerHTML={{ __html: theme.titleHtml }}
              />
              <p className="rl__subtitle">{theme.subtitle}</p>
            </header>

            {children}

            {meta && <div className="rl__meta">{meta}</div>}
          </div>

          {/* ── Editorial pane ── */}
          <aside className="rl__editorial" aria-hidden="true">
            <span className="rl__ed-kicker">{theme.edKicker}</span>
            <div className="rl__ed-numeral">{theme.numeral}</div>
            <p
              className="rl__ed-tagline"
              dangerouslySetInnerHTML={{ __html: theme.tagline }}
            />
            <p className="rl__ed-sub">{theme.taglineSub}</p>
            <div className="rl__ed-rule" />
            <dl className="rl__ed-manifest">
              {theme.manifest.map(([key, val]) => (
                <Fragment key={key}>
                  <dt>{key}</dt>
                  <dd>{val}</dd>
                </Fragment>
              ))}
            </dl>
            <div className="rl__ed-stamp">
              <span className="rl__brand-line">Paazio · Assess</span>
              <strong>{theme.edition}</strong>
            </div>
          </aside>
        </section>
      </main>

      <div className="rl__chrome-footer">
        <ProductFooter />
      </div>
    </div>
  );
}
